export const initDragableCta = () => {
    const ctaWindow = document.getElementById('cta-window');
    const ctaCloseButton = document.getElementById('cta-close');

    const CTA_DISPLAY_DURATION = 14 * 24 * 60 * 60 * 1000; // 2 weeks in milliseconds

    const isHomePage = [
        '/',
        '/home',
        '/de/',
        '/de/home',
        '/en/',
        '/en/home'
    ].includes(window.location.pathname);

    if (!ctaWindow || !isHomePage) {
        return false;
    }

    const shouldShowCta = () => {
        const ctaTimestamp = localStorage.getItem('ctaTimestamp');
        if (!ctaTimestamp) {
            return true;
        }

        const currentTime = Date.now();
        return currentTime - ctaTimestamp > CTA_DISPLAY_DURATION;
    };

    // Function to handle the close button click
    const handleCloseButtonClick = () => {
        ctaWindow.style.display = 'none';
        localStorage.setItem('ctaTimestamp', Date.now());
    };

    if (shouldShowCta()) {
        // Set up the draggable functionality
        interact('#cta-window').draggable({
            inertia: true,
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: 'parent',
                    endOnly: true
                })
            ],
            autoScroll: true,
            listeners: {
                move: dragMoveListener,
            }
        }).on('dragstart', (event) => {
            event.preventDefault(); // Prevent default touch action during drag
        });

        function dragMoveListener(event) {
            const target = event.target;
            const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
            const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            target.style.transform = `translate(${x}px, ${y}px)`;

            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
        }

        // Show the CTA window after setting up interact.js
        ctaWindow.style.display = 'block';

        // Set the timestamp in localStorage when the close button is clicked
        ctaCloseButton.addEventListener('click', handleCloseButtonClick);
    }

};
